var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_467_2266)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 1.8335C4.59441 1.8335 1.8335 4.59441 1.8335 8.00016C1.8335 11.4059 4.59441 14.1668 8.00016 14.1668C11.4059 14.1668 14.1668 11.4059 14.1668 8.00016C14.1668 4.59441 11.4059 1.8335 8.00016 1.8335ZM0.833496 8.00016C0.833496 4.04212 4.04212 0.833496 8.00016 0.833496C11.9582 0.833496 15.1668 4.04212 15.1668 8.00016C15.1668 11.9582 11.9582 15.1668 8.00016 15.1668C4.04212 15.1668 0.833496 11.9582 0.833496 8.00016ZM8.00016 5.16683C7.58595 5.16683 7.25016 5.50262 7.25016 5.91683C7.25016 6.19297 7.02631 6.41683 6.75016 6.41683C6.47402 6.41683 6.25016 6.19297 6.25016 5.91683C6.25016 4.95033 7.03366 4.16683 8.00016 4.16683C8.96666 4.16683 9.75016 4.95033 9.75016 5.91683C9.75016 6.55905 9.40393 7.11988 8.89034 7.42374C8.75917 7.50134 8.65089 7.58608 8.58035 7.66921C8.51186 7.74991 8.50016 7.80256 8.50016 7.8335V8.66683C8.50016 8.94297 8.27631 9.16683 8.00016 9.16683C7.72402 9.16683 7.50016 8.94297 7.50016 8.66683V7.8335C7.50016 7.49624 7.64781 7.22259 7.81789 7.02217C7.98591 6.82418 8.19542 6.67297 8.38114 6.56309C8.60312 6.43176 8.75016 6.1912 8.75016 5.91683C8.75016 5.50262 8.41438 5.16683 8.00016 5.16683ZM8.00016 11.3335C8.36835 11.3335 8.66683 11.035 8.66683 10.6668C8.66683 10.2986 8.36835 10.0002 8.00016 10.0002C7.63197 10.0002 7.3335 10.2986 7.3335 10.6668C7.3335 11.035 7.63197 11.3335 8.00016 11.3335Z",
    fill: "#1A1B1D",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_2266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.c4ef2ce15b23ed1112018c6700d19b88.svg";
export { ForwardRef as ReactComponent };